import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import urldata from "../../../../urldata";
import Imageurldata from "../../../../Imageurldata";
import { Dropdown, DropdownButton } from "react-bootstrap";
import Button from "../../../../component/Button/Button";
import { Col, Row, Modal } from "react-bootstrap";
import InputText from "../../../../component/InputText/InputText";

import upload from "../../../../images/careers/upload.svg";
import Toast from "../../../../component/Toast/Toast";
import close from "../../../../images/close.svg";
import check from "../../../../images/check.svg";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const expinyearsOptions = [
  {
    name: "",
  },
  {
    name: "Months",
  },
  {
    name: "Years",
  },
];

const ProductSubCategories = (props) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [exptabshow, setExptabshow] = useState(false);
  const [textline1, settextline1] = useState("");
  const [title, settitle] = useState("");
  const [unitErr, setUnitErr] = useState("");

  const [category, setcategory] = useState("");
  const [oldLogoTitle, setoldLogoTitle] = useState("");
  const [newLogoTitle, setnewLogoTitle] = useState("");
  const [oldLogoDescription, setoldLogoDescription] = useState("");
  const [newLogoDescription, setnewLogoDescription] = useState("");
  const [textline1err, settextline1err] = useState("");
  const [type, settype] = useState("Add");
  const [link, setlink] = useState("");
  const [linkerr, setlinkErr] = useState("");

  const [bannerimg, setbannerimg] = useState("");
  const [bannerimgerr, setbannerimgErr] = useState("");
  const [bannerimgnotpresent, setbannerimgnotpresent] = useState("");
  const [selectedCategory, setselectedCategory] = useState("");
  const [mbbannerimg, setmbbannerimg] = useState("");
  const [mbbannerimgerr, setmbbannerimgErr] = useState("");
  const [mbImgNotPresent, setmbImgNotPresent] = useState("");

  const [categories, setcategories] = useState([]);
  const [updateModel, setUpdateModel] = useState(false);
  const [showMobImg, setShowMobImg] = useState("");
  const [showDesktopImg, setShowDesktopImg] = useState("");

  const [bannerid, setbannerid] = useState("");

  const [toastlist, setToastList] = useState([]);

  let toastProperties = null;

  const showToast = (type) => {
    const id = Math.floor(Math.random() * 101 + 1);
    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: "Success",
          description: `Subcategory ${
            updateModel ? "updated" : "added"
          } Successfully`,
          backgroundColor: "#329F33",
          icon: check,
        };
        break;
      case "danger":
        toastProperties = {
          id,
          title: "Something Went Wrong",
          description: "",
          backgroundColor: "red",
          icon: close,
        };
        break;
      case "delete":
        toastProperties = {
          id,
          title: "Success",
          description: "Subcategory deleted Successfully",
          backgroundColor: "#329F33",
          icon: check,
        };
        break;

      default:
        setToastList([]);
    }

    setToastList([...toastlist, toastProperties]);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setUpdateModel(false);
    setShow(true);
    setShowMobImg(false);
    setShowDesktopImg(false);
    settitle("");
    settype("Add");
    setcategory("");
    settextline1("");
    setoldLogoDescription("");
    setoldLogoTitle("");
    setnewLogoDescription("");
    setnewLogoTitle("");
    setlink("");
    setbannerimg("");
    setmbbannerimg("");

    setselectedCategory(categories[0].title);
  };

  useEffect(() => {
    setLoading(true);

    let url = new URL(urldata + "admin/getBannerImages");
    axios({
      method: "get",
      url: urldata + "product/subcategory",
      //withCredentials: true,
    })
      .then((response) => {
        console.log(response);
        const templist = response.data.reverse();
        setList(templist);
        console.log(list);
        //setLoading(false);
      })
      .then(() => {
        axios({
          method: "get",
          url: urldata + "product/category",
          //withCredentials: true,
        })
          .then((response) => {
            console.log(response);
            console.log(response.data);
            const temp = response.data;
            setcategories(temp);
            console.log(categories);
            //   const templist = response.data.reverse();
            //   setList(templist);
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            //showToast("danger");
          });
      })
      .catch((error) => {
        setLoading(false);
        //showToast("danger");
      });
  }, []);

  const handleShowForUpdate = (rowData) => {
    console.log(rowData);
    setUpdateModel(true);
    setShow(true);
    settype("Update");
    settextline1(rowData.text);
    settitle(rowData.title);
    setcategory(rowData.category);
    setoldLogoDescription(rowData.oldLogoDescription);
    setoldLogoTitle(rowData.oldLogoTitle);
    setnewLogoDescription(rowData.newLogoDescription);
    setnewLogoTitle(rowData.newLogoTitle);
    setlink(rowData.buttonLink);
    // setmbbannerimg(Imageurldata + rowData.mobileImageUrl.replaceAll("\\","/"))
    // setbannerimg(Imageurldata + rowData.desktopImageUrl.replaceAll("\\","/"))
    // setmbImgNotPresent(rowData.mobileImageUrl.replaceAll("\\","/") ? false: true)
    // setbannerimgnotpresent(rowData.desktopImageUrl.replaceAll("\\","/") ? false: true)

    setbannerid(rowData._id);
    setselectedCategory(rowData.category);
    setShowMobImg(false);
    setShowDesktopImg(false);
    setUnitErr("");
  };

  const updateBanner = () => {
    var formData = new FormData();
    formData.append("oldLogoDescription", oldLogoDescription);
    formData.append("oldLogoTitle", oldLogoTitle);
    formData.append("newLogoDescription", newLogoDescription);
    formData.append("newLogoTitle", newLogoTitle);
    //formData.append("category", category);
    formData.append("screen", "home");
    formData.append("title", title);
    formData.append("category", selectedCategory);
    if (mbImgNotPresent) {
      formData.append("mobileImageUrl", mbbannerimg);
      setmbImgNotPresent(false);
    }

    if (bannerimgnotpresent) {
      formData.append("desktopImageUrl", bannerimg);
      setbannerimgnotpresent(false);
    }

    let url = new URL(urldata + "admin/updateBannerImages");
    formData.append("id", bannerid);
    //url.searchParams.append('id', bannerid)
    var decoded = decodeURIComponent(url);

    axios({
      method: "post",
      url: urldata + "product/subcategory/update",
      data: formData,
      //withCredentials: true,/banner/udpate
    })
      .then((response) => {
        const templist = response.data.reverse();
        setList(templist);
        showToast("success");
        setShow(false);
      })
      .catch((error) => {
        console.log("error--", error);
        setShow(false);
        // showToast("danger");
      });
  };

  const createbanner = () => {
    var formData = new FormData();
    formData.append("oldLogoDescription", oldLogoDescription);
    formData.append("oldLogoTitle", oldLogoTitle);
    formData.append("newLogoDescription", newLogoDescription);
    formData.append("newLogoTitle", newLogoTitle);
    formData.append("title", title);

    formData.append("buttonLink", link);
    formData.append("screen", "home");
    formData.append("mobileImageUrl", mbbannerimg);
    formData.append("desktopImageUrl", bannerimg);

    formData.append("category", selectedCategory);
    let url = new URL(urldata + "admin/addBannerImages");

    axios({
      method: "post",
      url: urldata + "product/subcategory/new",
      data: formData,
      // withCredentials: true,
    })
      .then((response) => {
        // settextline1("");
        // settextline2("");
        // settextline3("");
        // setlink("");
        // setbannerimg("");
        // setmbbannerimg("");
        console.log(response);
        const templist = response.data.reverse();
        setList(templist);
        showToast("success");
        setShow(false);
      })
      .catch((error) => {
        // showToast("danger");
      });
  };

  const submit = () => {
    var formIsValid = true;

    if (!title) {
      formIsValid = false;
      setUnitErr("*Please fill Subcategory.");
    } else {
      setUnitErr("");
    }
    // if (!bannerimg) {
    //   formIsValid = false;
    //   setbannerimgErr("*Please upload desktop banner image.");
    // } else {
    //   setbannerimgErr("");
    // }

    // if (!mbbannerimg) {
    //   formIsValid = false;
    //   setmbbannerimgErr("*Please upload mobile  banner image.");
    // } else {
    //   setmbbannerimgErr("");
    // }

    // <<<<<<< HEAD
    // if (bannerimg) {
    //   if (bannerimg.size / 1024 > 300) {
    //     formIsValid = false
    //     setbannerimgErr("*File should be less than 300Kb.");
    //   }
    // }
    // if (mbbannerimg) {
    //   if (mbbannerimg.size / 1024 > 300) {
    //     formIsValid = false
    //     setmbbannerimg("*File should be less than 300Kb.");
    //   }
    // }

    // =======
    // >>>>>>> vijay
    if (formIsValid) {
      if (updateModel) {
        updateBanner();
      } else {
        createbanner();
      }
    }
  };
  const selectCategory = (val) => {
    //val
    setselectedCategory(val);
    console.log(typeof val);
  };

  const deleteBtnClick = (id) => {
    setLoading(true);
    let data = {};
    data.id = id;

    let url = new URL(urldata + "admin/deleteBannerImage");

    axios({
      method: "post",
      url: urldata + "product/subcategory/delete",
      data: data,
      // withCredentials: true,
    })
      .then((response) => {
        //   showToast("success");
        //   props.onHide(); props.history.push('/admin/login')

        const templist = response.data.reverse();
        setList(templist);
        setLoading(false);
        showToast("delete");
      })
      .catch((error) => {
        // showToast("danger");
        setLoading(false);
      });
  };

  if (loading) {
    return (
      <div id="wrapper">
        <div className="profile-main-loader">
          <div className="loader">
            <svg className="circular-loader" viewBox="25 25 50 50">
              <circle
                className="loader-path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke="#ed1c24"
                stroke-width="2"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="addjobinlist text-right mb-4">
        <Button title="Add Subcategory" onClick={handleShow} />
      </div>
      <MaterialTable
        title="Subcategory List"
        columns={[
          { title: "Subcategory name", field: "title" },
          { title: "Category", field: "category" },

          {
            field: "url",

            title: "Action  ",
            render: (rowData) => (
              <div className="d-f">
                <Button
                  title=" Update"
                  onClick={() => {
                    handleShowForUpdate(rowData);
                  }}
                ></Button>
                <Button
                  title=" Delete"
                  onClick={() => deleteBtnClick(rowData._id)}
                ></Button>
              </div>
            ),
          },
        ]}
        data={list}
        options={{
          exportButton: true,
          actionsColumnIndex: -1,
        }}
      />

      <Modal
        {...props}
        //   size="lg"
        //   aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="addbannerModel"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="model">
          <div className="title">{type} Subcategory</div>

          <Row>
            <Col lg={3} className="column">
              <div className="titleitem">{type} category </div>
            </Col>
            <Col lg={9} className="column">
              <DropdownButton
                id="dropdown-basic-button"
                onSelect={(e) => selectCategory(e)}
                title={selectedCategory}
              >
                {/* <input
                value={category}
                onChange={(e) => setcategory(e.target.value)}
                // maxlength="31"
                type="text"
              /> */}

                {categories.map((cat, index) => {
                  console.log(cat);
                  return (
                    <Dropdown.Item
                      value={cat.title}
                      eventKey={cat.title}
                      key={index}
                    >
                      {cat.title}
                    </Dropdown.Item>
                  );
                })}

                {/* <div className="count">{textline1.length}/31</div> */}
              </DropdownButton>
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">{type} Subcategory name</div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={title}
                onChange={(e) => settitle(e.target.value)}
                // maxlength="31"
                type="text"
              />
              <div className="err">{unitErr} </div>

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>

            {/* <Col lg={3} className="column">
              <div className="titleitem">Add Desktop Image</div>
              <div className="desc">Size :- 2560 × 1306</div>
            </Col>
            <Col lg={9} className="column">
              <input
                id="bannerImage"
                accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG"
                type="file"
                onChange={(e) => {
                  setbannerimg(e.target.files[0]);
                  setShowDesktopImg(true);
                  setbannerimgnotpresent(true)
                }}
                name="passport_proof_upload"
              />

              <label for="bannerImage" className="d-f" id="file-drag">
                <img src={upload} class="img-fluid" />
                <div class="chooseTxt">Choose File</div>
              </label>

              <div className="d-f jc-sb">
                <div className="fileTxt">File Format : JPG / PNG</div>
              </div>
              <div className="err">{bannerimgerr} </div>

              <div>
                {bannerimg !== "" && (
                  <img
                    src={showDesktopImg ? URL.createObjectURL(bannerimg) : bannerimg}
                    className="img-fluid"
                    style={{ width: "100px", height: "100px" }}
                  />
                )}
              </div>
            </Col>

            <Col lg={3} className="column">
              <div className="titleitem">Add Mobile Image</div>
              <div className="desc">Size :- 640 × 630</div>
            </Col>
            <Col lg={9} className="column">
              <input
                id="bannerImage1"
                accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG "
                type="file"
                onChange={(e) => {
                  setmbbannerimg(e.target.files[0]);
                  setShowMobImg(true);
                  setmbImgNotPresent(true);
                }}
                name="passport_proof_upload"
              />

              <label for="bannerImage1" className="d-f" id="file-drag">
                <img src={upload} class="img-fluid" />
                <div class="chooseTxt">Choose File</div>
              </label>

              <div className="d-f jc-sb">
                <div className="fileTxt">File Format : JPG / PNG</div>
              </div>
              <div className="err">{mbbannerimgerr} </div>

              <div>
                {mbbannerimg !== "" && (
                  <img
                    src={showMobImg ? URL.createObjectURL(mbbannerimg) : mbbannerimg}
                    className="img-fluid"
                    style={{ width: "100px", height: "100px" }}
                  />
                )}
              </div>
            </Col> */}
          </Row>
          <div className="btnContainer mt-4">
            <Button onClick={submit} title="SUBMIT" />
          </div>
        </Modal.Body>
      </Modal>
      <Toast toastList={toastlist} position="top-right" />
    </>
  );
};

export default ProductSubCategories;

// updateBannerImages
